export default __webpack_public_path__ + "static/media/water7.8ec6a628.png";